var skanGym = skanGym || {};

$(function () {
	skanGym.scrollTo.scrollToTop($('#scroll-to-top'));
});

skanGym.scrollTo = new function(selector){

	this.scrollToTop = function(selector) {
		selector.click(function() {

			$('html,body').animate({
				scrollTop: $('html').offset().top
			}, 500);

		});
	};

};